import styled from 'styled-components'
import CreationToolSupercutField from '../../../../../../types/super-cut-field'
import WatermarkFileField from '../../../../../form-fields/super-cut/watermark-file'

const WatermarkFile = styled(WatermarkFileField)`
    grid-column: span 2;
`

type Props = {
    field: CreationToolSupercutField
}

const CreationCaptureInfoWatermarkFileField = ({ field }: Props) => {
    return (
        <WatermarkFile
            {...{
                field,
            }}
        />
    )
}

export default CreationCaptureInfoWatermarkFileField
